import * as React from 'react';

import Sandbox140 from './Sandbox140';

export const sandbox140 = () => <Sandbox140 />;

export default {
    title: 'Illustration|Sandbox140',
    component: Sandbox140,
    parameters: {
        notes: "`import Sandbox140 from 'box-ui-elements/es/illustration/Sandbox140';`",
    },
};
